//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import image from '~/assets/img/StoreFinder.jpg';
import backIcon from '~/assets/img/icons/arrow-left.svg?raw'
import ResponsiveImage from "@/components/common/ResponsiveImage";
export default {
    name: "ShopView",
    components: {ResponsiveImage},
    props: {
        shop: {
            type: Object,
            default: () => { return {} }
        }
    },
    data() {
        return {
            backIcon: backIcon,
        }
    },
    computed: {
        imageShop() {
            return {
                src: {
                    desktop: {
                        '1x': image,
                        '2x': image,
                    },
                    tablet: {
                        '1x': image,
                        '2x': image,
                    },
                    mobile: {
                        '1x': image,
                        '2x': image,
                    },
                },
                title: this.shop.title,
                alt: this.shop.title,
            }
        },
        hrefAddress() {
            return 'https://www.google.com/maps/search/?api=1&query='+this.shop.coordinates.lat+','+this.shop.coordinates.lng;
        },
        workHours() {
            let result = [];

            if (this.shop.openingHours) {
                let dayPoints = [],
                    scheduleVariant = [];
                dayPoints.push({start: this.shop.openingHours[0].name});
                scheduleVariant.push(this.shop.openingHours[0]);
                this.shop.openingHours.forEach((i, index) => {
                    let last = scheduleVariant[scheduleVariant.length - 1];
                    if (last.from !== i.from || last.to !== i.to) {
                        scheduleVariant.push(i);
                        dayPoints[dayPoints.length - 1].end = this.shop.openingHours[index - 1].name;
                        dayPoints.push({start: i.name})
                    }
                });
                dayPoints[dayPoints.length - 1].end =  this.shop.openingHours[this.shop.openingHours.length - 1].name;

                scheduleVariant.forEach((i, index) => {
                    result.push({
                        label: dayPoints[index].start !== dayPoints[index].end ? this.$t(`static.days.${dayPoints[index].start}`) +'-'+this.$t(`static.days.${dayPoints[index].end}`) : this.$t(`static.days.${dayPoints[index].start}`),
                        value: this.$t('static.storeFinder.from') +' '+ i.from +' '+this.$t('static.storeFinder.to') +' '+i.to
                    })
                })
            }
            return result;
        }
    },
    methods: {
        clearActive() {
            this.$store.commit('storefinder/SET_ACTIVE_STORE', {});
        }
    }
}
